import { InputText } from 'primereact/inputtext';
import React from 'react';

const PrwInputText = (props: any) => {
  // console.log('input props ---');
  // console.log(props);
  return (
    <InputText disabled={props.disabled} className={`p-d-block p-inputtext-sm ${props?.rawErrors?.length > 0 ? 'p-invalid': null}`} value={props.value || ""} onChange={(e:any) => props.onChange(e.target.value)} />
  )
};

export default PrwInputText;
